import UpdatePasswordPage from "./UpdatePasswordPage";
export default UpdatePasswordPage;
